import React, { useState } from 'react';
import { addUser } from '../../services/user';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../store/thunks/authThunks';

const AddUser = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authToken = useSelector((state) => state.auth.token);
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    mobile: '',
    gender: 'male',
    role: 'admin',
    password: '',
    age: '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    await addUser(formData, authToken.token)
      .then(response=>{
      setLoading(false);
      navigate('/user');
    })
    .catch(error=>{
      setLoading(false);
      if(error.response?.data?.error && error.response?.data?.error.toLowerCase()==='invalid token'){
        handleLogout();
      } 
    });
  };

  const handleLogout = () => {
      dispatch(logout());
      navigate('/login');
    };

  return (
    <div className="p-6 space-y-6 bg-white">
      {/* Breadcrumb */}
      <div className="text-sm text-gray-500">
        <span className="text-blue-600 cursor-pointer" onClick={() => navigate('/user')}>User</span> &gt; Add
      </div>

      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold">Add New User</h2>
        <button
          className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300 cursor-pointer"
          onClick={() => navigate('/user')}
        >
          Back to List
        </button>
      </div>

      <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {['first_name', 'last_name', 'email', 'mobile', 'password', 'age'].map((field) => (
          <div key={field}>
            <label className="block mb-1 capitalize">{field.replace('_', ' ')}</label>
            <input
              type={field === 'password' ? 'password' : 'text'}
              name={field}
              value={formData[field]}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 px-3 py-2 rounded"
            />
          </div>
        ))}

        <div>
          <label className="block mb-1">Gender</label>
          <select
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            className="w-full border border-gray-300 px-3 py-2 rounded"
          >
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
        </div>

        <div>
          <label className="block mb-1">Role</label>
          <select
            name="role"
            value={formData.role}
            onChange={handleChange}
            className="w-full border border-gray-300 px-3 py-2 rounded"
          >
            <option value="admin">Admin</option>
            <option value="teacher">Teacher</option>
            <option value="executive">Executive</option>
          </select>
        </div>

        <div className="md:col-span-2">
          <button
            type="submit"
            disabled={loading}
            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
          >
            {loading ? 'Submitting...' : 'Add User'}
          </button>
        </div>

        {error && <p className="md:col-span-2 text-red-500">{error}</p>}
      </form>
    </div>
  );
}

export default AddUser
